import Decimal from "decimal.js";
import { DEFAULT_PART_PRICE_READJUSTMENT_MODE, PartPriceReadjustmentMode } from "../interface/part-price-readjustment-mode";

export class PriceReadjustmentUtilities {

  static normalizeMode(mode: unknown): PartPriceReadjustmentMode {
    return mode === "margin" ? "margin" : DEFAULT_PART_PRICE_READJUSTMENT_MODE;
  }

  /**
   * Sale value for `base` (cost) readjusted by `percentage`.
   * Markup: `base * (1 + p/100)`. Margin: `base / (1 - p/100)`; a margin of 100% or more has no sale value (`undefined`).
   */
  static saleValue(base: number, percentage: number, mode: PartPriceReadjustmentMode = DEFAULT_PART_PRICE_READJUSTMENT_MODE): number | undefined {
    const rate = new Decimal(percentage ?? 0).div(100);
    const cost = new Decimal(base ?? 0);
    if (mode === "margin") {
      if (rate.gte(1)) return undefined;
      if (rate.lte(0)) return cost.toNumber();
      return cost.div(new Decimal(1).minus(rate)).toNumber();
    }
    return cost.times(new Decimal(1).plus(rate)).toNumber();
  }

  /** Percentage that turns `base` (cost) into `saleValue`, in the given mode. */
  static percentage(base: number, saleValue: number, mode: PartPriceReadjustmentMode = DEFAULT_PART_PRICE_READJUSTMENT_MODE): number {
    const sale = new Decimal(saleValue ?? 0);
    const cost = new Decimal(base ?? 0);
    if (mode === "margin") {
      if (sale.isZero()) return 0;
      return sale.minus(cost).div(sale).times(100).toNumber();
    }
    if (cost.isZero()) return 0;
    return sale.div(cost).minus(1).times(100).toNumber();
  }
}
